import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import deepFreeze from '../Helpers/deep-freezer';

const GlobalStateContext = createContext();

const defaultValues = {
  language: 'en',
};

const loadStateFromLocalStorage = () => {
  try {
    const saved = JSON.parse(localStorage.getItem('globalState') || '{}');

    return {
      ...defaultValues,
      ...saved,
    };
  } catch {
    return defaultValues;
  }
};

export const GlobalStateProvider = ({ children }) => {
  const [globalState, setGlobalState] = useState(loadStateFromLocalStorage);

  useEffect(() => {
    localStorage.setItem('globalState', JSON.stringify(globalState));
  }, [globalState]);

  const updateGlobalState = (newState) => {
    setGlobalState((prevState) => ({
      ...prevState,
      ...newState,
    }));
  };

  const memoizedState = useMemo(
    () => ({
      globalState: deepFreeze(globalState),
      updateGlobalState,
    }),
    [globalState]
  );

  return (
    <GlobalStateContext.Provider value={memoizedState}>
      {children}
    </GlobalStateContext.Provider>
  );
};

export const useGlobalState = () => useContext(GlobalStateContext);
